import { useState, useEffect } from "react";
import AutocompleteInput from "./AutocompleteInput";
import { Filter, X } from "lucide-react";
import { createPortal } from "react-dom";

export default function FilterSidebar({ onChange, onClear,  }) {
  const [open, setOpen] = useState(false);

  const [filters, setFilters] = useState({
    id_vendor: "",
    id_event: "",
    user_input: "",
    read: "",
    trf: "",
    type:[]
  });

  useEffect(() => {
    onChange(filters);
  }, [filters]);

  const clearFilter = () => {
    onClear();
    setFilters({
      id_vendor: "",
      id_event: "",
      user_input: "",
      read: "",
      trf: "",
      type:[]
    });
    // trigger parent reload
  };

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const typeOptions = [
    { label: "Permintaan Uang Muka", value: "um" },
    { label: "Reimbursement", value: "reimburse" },
    { label: "DP ke Vendor/Talent", value: "dp" },
    { label: "Pelunasan ke Vendor/Talent", value: "pelunasan" },
  ];

  return (
    <>
      {/*  FLOATING BUTTON */}
      <button
        onClick={() => setOpen(true)}
        className="flex flex-row bg-gradient-to-bl items-center  from-blue-500 to-cyan-500 text-white p-2 rounded-2xl shadow-lg hover:scale-110 transition gap-2"
      >
        <Filter size={14}></Filter> Advance Filter
      </button>

      {/* 🔥 OVERLAY */}
      {mounted && open &&
        createPortal(
        <>
          <div
            onClick={() => setOpen(false)}
            className="fixed inset-0 bg-black/30 z-40"
          />
          <div
            className={`
              fixed top-0 left-0 h-full w-[300px] bg-white z-50 shadow-xl
              transform transition-all duration-500
            `}
            style={{
              transitionTimingFunction: "cubic-bezier(0.34,1.56,0.64,1)" // 🔥 bounce
            }}
          >
            {/* HEADER */}
            <div className="flex justify-between items-center p-4 border-b">
              <h2 className="font-semibold">Filter</h2>
              <button onClick={() => setOpen(false)}><X></X></button>
            </div>

            {/* CONTENT */}
            <div className="p-4 space-y-4">

              {/* VENDOR */}
              <AutocompleteInput
                placeholder="Vendor..."
                url="/api/autocomplete/vendor"
                onSelect={(v) =>
                  setFilters((f) => ({ ...f, id_vendor: v.id }))
                }
              />

              {/* EVENT */}
              <AutocompleteInput
                placeholder="Event..."
                url="/api/autocomplete/event"
                onSelect={(e) =>
                  setFilters((f) => ({ ...f, id_event: e.id }))
                }
              />

              {/* PIC */}
              <AutocompleteInput
                placeholder="PIC..."
                url="/api/autocomplete/pic"
                valueKey="email"
                onSelect={(p) =>
                  setFilters((f) => ({ ...f, user_input: p.email }))
                }
              />

              {/* STATUS */}
              <select
                className="w-full border p-2 rounded-2xl"
                value={filters.read}
                onChange={(e) =>
                  setFilters((f) => ({ ...f, read: e.target.value }))
                }
              >
                <option value="">-- Status Print --</option>
                <option value="read">Sudah Print</option>
                <option value="unread">Belum Print</option>
              </select>

              {/* TRF */}
              <select
                className="w-full border p-2 rounded-2xl"
                value={filters.trf}
                onChange={(e) =>
                  setFilters((f) => ({ ...f, trf: e.target.value }))
                }
              >
                <option value="">-- Status Transfer --</option>
                <option value="1">Sudah Transfer</option>
                <option value="0">Belum Transfer</option>
              </select>
              <div className="flex flex-wrap gap-2">
                {typeOptions.map((item) => {
                  const active = filters.type.includes(item.value);

                  return (
                    <button
                      key={item.value}
                      onClick={() => {
                        setFilters((f) => ({
                          ...f,
                          type: active
                            ? f.type.filter((x) => x !== item.value)
                            : [...f.type, item.value]
                        }));
                      }}
                      className={`
                        px-3 py-1 rounded-full text-sm border transition
                        ${
                          active
                            ? "bg-blue-500 text-white border-blue-500"
                            : "bg-gray-100 hover:bg-gray-200"
                        }
                      `}
                    >
                      {item.label}
                    </button>
                  );
                })}
              </div>
              <div className="grid grid-cols-1 gap-2">
                <div className="text-md flex flex-col ">
                  Dari:
                  <input
                    type="date"
                    value={filters.startDate}
                    onChange={(e) =>
                      setFilters((f) => ({ ...f, startDate: e.target.value }))
                    }
                    className="border p-2 rounded"
                  />
                </div>
                <div className="text-md flex flex-col ">
                  Hingga:
                  <input
                    type="date"
                    value={filters.endDate}
                    onChange={(e) =>
                      setFilters((f) => ({ ...f, endDate: e.target.value }))
                    }
                    className="border p-2 rounded"
                  />
                </div>
              </div>

              {/* ACTION BUTTON */}
              <div className="flex gap-2 pt-4">
                <button
                  onClick={clearFilter}
                  className="flex-1 bg-red-500 border border-red-300 bg-gradient-to-br from-red-500 to-orange-500 hover:scale-105 text-white transition-transform rounded-2xl"
                >
                  Clear
                </button>

                <button
                  onClick={() => setOpen(false)}
                  className="flex-1 bg-gradient-to-bl items-center  from-blue-500 to-cyan-500 text-white p-2 rounded-2xl shadow-lg hover:scale-110 transition "
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        </>,
        document.body
      )}

      {/* 🔥 SIDEBAR */}
      
    </>
  );
}